import { MainStatsWrapper } from '../stats/main-stats';
import { ExpandableCardLoading } from '../stats/audit-stats';
import { twMerge } from 'tailwind-merge';
import Button from 'modules/shared-components/button/button';

export const LoadingTerminalDesktop = ({
  isSidebarOpen,
}: {
  isSidebarOpen?: boolean;
}) => {
  return (
    <div className="hidden lg:block">
      <div className="space-y-0 pb-16 lg:pb-0 lg:space-y-1">
        <div
          className={twMerge(
            isSidebarOpen ? 'lg:grid-cols-6' : 'lg:grid-cols-1',
            ' xxs:py-1 lg:grid'
          )}
        >
          {isSidebarOpen && (
            <div className="xxs:hidden lg:block lg:sticky lg:top-0 lg:overflow-y-auto lg:h-terminalNew border-tailwind xxs:border xxs:border-b-0 xxs:border-x-0 xxs:border-dex-black-700">
              <div className="xxs:space-y-1">
                <div className="xxs:space-y-1 ">
                  <div className="xxs:space-y-1 xxs:h-[60px] border-tailwind xxs:border-x-0 xxs:border-t-0 xxs:border-dex-black-700 xxs:p-2 flex flex-col items-center justify-center">
                    <div className="xxs:flex xxs:space-x-1 items-center">
                      <div className="xxs:h-2 my-2 rounded-full xxs:bg-dex-black-700 w-[100px]">
                        &nbsp;
                      </div>
                    </div>
                  </div>

                  <div className="xxs:p-2 xxs:space-y-1">
                    <MainStatsWrapper contract={undefined} />
                    <ExpandableCardLoading>
                      <div className="xxs:text-dex-white-secondary">Audit</div>
                    </ExpandableCardLoading>
                    <ExpandableCardLoading>
                      <div className="xxs:text-dex-white-secondary">
                        Contract Info
                      </div>
                    </ExpandableCardLoading>
                    <ExpandableCardLoading>
                      <div className="xxs:text-dex-white-secondary">
                        Owner Info
                      </div>
                    </ExpandableCardLoading>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={twMerge(isSidebarOpen ? 'col-span-5' : 'col-span-1')}>
            <div className="flex">
              <div className="w-4/5 flex flex-col overflow-hidden w-full col-span-5 border-tailwind xxs:border xxs:border-dex-black-700">
                <div className="flex items-center h-[60px] xxs:p-2 border-tailwind xxs:border-x-0 xxs:border-t-0 xxs:border xxs:border-dex-black-700">
                  <div className="space-y-2">
                    <div className="xxs:h-3 my-2 rounded-full xxs:bg-dex-black-700 w-[100px]">
                      &nbsp;
                    </div>
                    <div
                      className="xxs:h-2 my-1  rounded-full xxs:bg-dex-black-700  w-full"
                      style={{ minWidth: 12, maxWidth: '64px' }}
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
              <div className=" lg:h-terminalNew w-1/5 border-tailwind xxs:border xxs:border-b-0 xxs:border-x-0 xxs:border-dex-black-700">
                <div className="xxs:space-y-1 xxs:h-[60px] border-tailwind xxs:border-x-0 xxs:border-t-0 xxs:border-dex-black-700 xxs:p-2 flex flex-col items-center justify-center">
                  <div className="xxs:flex xxs:space-x-1 items-center">
                    <div className="xxs:h-2 my-2 rounded-full xxs:bg-dex-black-700 w-[100px]">
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LoadingTerminalMobile = () => {
  return (
    <div className="lg:hidden">
      <div className="space-y-0 pb-12">
        <div className="xxs:px-2 h-10 border-tailwind xxs:border-solid xxs:border-dex-black-700 xxs:border-x-0 xxs:border-t-0 grid-cols-4 grid space-x-1">
          <div className="xxs:h-3 my-2 rounded-full xxs:bg-dex-black-700 w-[75px]">
            &nbsp;
          </div>
          <div className="xxs:h-3 my-2 rounded-full xxs:bg-dex-black-700 w-[75px]">
            &nbsp;
          </div>
          <div className="xxs:h-3 my-2 rounded-full xxs:bg-dex-black-700 w-[75px]">
            &nbsp;
          </div>
          <div className="xxs:h-3 my-2 rounded-full xxs:bg-dex-black-700 w-[75px]">
            &nbsp;
          </div>
        </div>
        <div className="flex flex-col overflow-hidden w-full border-tailwind xxs:border xxs:border-dex-black-700">
          <div className="flex items-center h-[60px] xxs:p-2 border-tailwind xxs:border-x-0 xxs:border-t-0 xxs:border xxs:border-dex-black-700">
            <div className="space-y-2">
              <div className="xxs:h-3 my-2 rounded-full xxs:bg-dex-black-700 w-[100px]">
                &nbsp;
              </div>
              <div
                className="xxs:h-2 my-1  rounded-full xxs:bg-dex-black-700  w-full"
                style={{ minWidth: 12, maxWidth: '64px' }}
              >
                &nbsp;
              </div>
            </div>
          </div>
          <div
            className={twMerge(` xxs:w-full flex items-center justify-center`)}
          ></div>
        </div>
        <div className=" lg:h-terminalNew border-tailwind xxs:border xxs:border-b-0 xxs:border-x-0 xxs:border-dex-black-700">
          <div className="xxs:space-y-1 xxs:h-[250px] border-tailwind xxs:border-x-0 xxs:border-t-0 xxs:border-dex-black-700 xxs:p-2 flex flex-col items-center justify-center">
            <div className="xxs:flex xxs:space-x-1 items-center">
              <div className="xxs:h-2 my-2 rounded-full xxs:bg-dex-black-700 w-[100px]">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
        <div className="fixed left-0 right-0 bottom-0 xxs:px-2 xxs:py-4 w-full flex">
          <Button
            variant="primary"
            type="button"
            onClick={() => {}}
            className="w-full xxs:text-base lg:text-xs"
          >
            <div className="xxs:h-2 my-2 rounded-full xxs:bg-dex-white w-[100px]">
              &nbsp;
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};
export const LoadingComponent = ({
  isSidebarOpen,
}: {
  isSidebarOpen?: boolean;
}) => {
  return (
    <>
      <LoadingTerminalDesktop isSidebarOpen={isSidebarOpen} />
      <LoadingTerminalMobile />
    </>
  );
};
